/* The custom builders' add-ons and cart, for the Custom CUBE and the Custom FRAME (one file since 2026-10-25; moved out of
   their sections 2026-10-24). */

function cfSafeOn(id, event, handler, options) {
  const el = document.getElementById(id);
  if (!el) return;
  el.addEventListener(event, handler, options || false);
  return el;
}

function allATC() {
  return document.querySelectorAll('.add-all-to-cart');
}

function formatCents(cents) {
  /*
    As checkout writes it, in the page's language and market (window.cfMoney, js-variables), whatever the browser speaks.
    See cfMoney in js-variables.
  */
  return window.cfMoney(cents, window.CF.LOCALE.moneyFormat);
}

function formatPrice(cents) {
  /*
    The price this page sells - its total, compare-at and saving - without ".00" when it has no cents, as
    price-list prints it. See cfPrice in js-variables.
  */
  return window.cfPrice(cents, window.CF.LOCALE.moneyFormat);
}

function getSelectedDisplayCover() {
  return window.CF.STATE.choices.cover;
}

function cfInitAddonVariants() {
  const data = window.CF.PRODUCT_DATA;
  const acrylicIdEl = document.getElementById('addon-acrylic-id');
  if (acrylicIdEl) {
    acrylicIdEl.value = data.cover.acrylicId;
    acrylicIdEl.setAttribute('data-price-cents', data.cover.acrylicPriceCents);
  }
  const glassIdEl = document.getElementById('addon-glass-id');
  if (glassIdEl) {
    glassIdEl.value = data.cover.glassId;
    glassIdEl.setAttribute('data-price-cents', data.cover.glassPriceCents);
  }
  const priceAcrylic = document.getElementById('price-acrylic-total');
  if (priceAcrylic) priceAcrylic.textContent = '+' + formatCents(data.cover.acrylicPriceCents);
  const priceGlass = document.getElementById('price-glass-total');
  if (priceGlass) priceGlass.textContent = '+' + formatCents(data.cover.glassPriceCents);
}

function updateDisplayCoverQuantities(count, displayCover) {
  const acrylicId  = document.getElementById('addon-acrylic-id');
  const acrylicQty = document.getElementById('addon-acrylic-qty');
  const glassId    = document.getElementById('addon-glass-id');
  const glassQty   = document.getElementById('addon-glass-qty');
  if (acrylicId && acrylicQty) {
    if (displayCover === 'acrylic' && count > 0) {
      acrylicId.disabled = false; acrylicQty.disabled = false; acrylicQty.value = count;
    } else {
      acrylicId.disabled = true;  acrylicQty.disabled = true;  acrylicQty.value = 0;
    }
  }
  if (glassId && glassQty) {
    if (displayCover === 'glass' && count > 0) {
      glassId.disabled = false; glassQty.disabled = false; glassQty.value = count;
    } else {
      glassId.disabled = true;  glassQty.disabled = true;  glassQty.value = 0;
    }
  }
}

function updateDisplayCoverTotal() {
  const acrylicTotalEl = document.getElementById('price-acrylic-total');
  const glassTotalEl = document.getElementById('price-glass-total');
  if (acrylicTotalEl) acrylicTotalEl.innerHTML = '+' + formatCents(window.CF.PRODUCT_DATA.cover.acrylicPriceCents);
  if (glassTotalEl) glassTotalEl.innerHTML = '+' + formatCents(window.CF.PRODUCT_DATA.cover.glassPriceCents);
}

function updatePlaqueTotal() {
  const materials = window.CF.CONSTANTS.PLAQUE_MATERIALS || {};
  ['steel', 'brass'].forEach(mat => {
    const def = materials[mat];
    if (!def) return;
    const totalEl = document.getElementById(`price-plaque-${mat}-total`);
    if (totalEl) totalEl.textContent = '+' + formatCents(Number(def.priceCents) || 0);
  });
}

function applyPlaqueVariant() {
  const addonPlaqueId = document.getElementById('addon-plaque-id');
  if (!addonPlaqueId) return;
  const mat = window.CF.STATE.plaqueMaterial || 'steel';
  const def = window.CF.CONSTANTS.PLAQUE_MATERIALS?.[mat];
  if (!def) return;
  addonPlaqueId.value = def.id;
  addonPlaqueId.setAttribute('data-price-cents', def.priceCents);
}

function updatePlaqueMaterialUI() {
  const steel = document.getElementById('option-button-plaque-steel');
  const brass = document.getElementById('option-button-plaque-brass');
  const mat = window.CF.STATE.plaqueMaterial || 'steel';
  const isEnabled = window.CF.STATE.choices.plaque;
  if (steel && brass) {
    steel.classList.toggle('active', isEnabled && mat === 'steel');
    brass.classList.toggle('active', isEnabled && mat === 'brass');
  }
  document.querySelectorAll('.plaque-image-steel').forEach(img => img.style.display = mat === 'steel' ? 'block' : 'none');
  document.querySelectorAll('.plaque-image-brass').forEach(img => img.style.display = mat === 'brass' ? 'block' : 'none');
}

function setDisplayCover(cover) {
  window.CF.STATE.choices.cover = cover;
  const acrylicId  = document.getElementById('addon-acrylic-id');
  const glassId    = document.getElementById('addon-glass-id');
  if (acrylicId) acrylicId.disabled = true;
  const acrylicWrapper = document.getElementById('option-button-acrylic');
  if (acrylicWrapper) acrylicWrapper.classList.remove('active');
  if (glassId) glassId.disabled = true;
  const glassWrapper = document.getElementById('option-button-glass');
  if (glassWrapper) glassWrapper.classList.remove('active');

  if (cover === 'acrylic') {
    if (acrylicWrapper) acrylicWrapper.classList.add('active');
    if (acrylicId)      acrylicId.disabled = false;
  } else if (cover === 'glass') {
    if (glassWrapper) glassWrapper.classList.add('active');
    if (glassId)      glassId.disabled = false;
  }
  updateUI();
}

function setPlaque(type) {
  const isEnabled = (type !== 'none');
  window.CF.STATE.choices.plaque = isEnabled;

  const addonPlaqueId   = document.getElementById('addon-plaque-id');
  const addonPlaqueQty  = document.getElementById('addon-plaque-qty');
  const addonPlaqueNote = document.getElementById('addon-plaque-note');
  const customizeCollapse = document.getElementById('cc-plaque-customize-collapse');
  /*  Disabled while folded away, as on the CUBE page, so the button cannot take focus out of sight. */
  const designBtn = document.getElementById('plaque-design-btn');

  if (isEnabled) {
    if (addonPlaqueId) addonPlaqueId.disabled = false;
    if (addonPlaqueQty) addonPlaqueQty.disabled = false;
    if (addonPlaqueNote) addonPlaqueNote.disabled = false;
    if (customizeCollapse) customizeCollapse.classList.add('is-open');
    if (designBtn) designBtn.disabled = false;
    applyPlaqueVariant();
    updatePlaqueMaterialUI();
  } else {
    if (addonPlaqueId) addonPlaqueId.disabled = true;
    if (addonPlaqueQty) addonPlaqueQty.disabled = true;
    if (addonPlaqueNote) addonPlaqueNote.disabled = true;
    if (customizeCollapse) customizeCollapse.classList.remove('is-open');
    if (designBtn) designBtn.disabled = true;
    const steel = document.getElementById('option-button-plaque-steel');
    const brass = document.getElementById('option-button-plaque-brass');
    if (steel) steel.classList.remove('active');
    if (brass) brass.classList.remove('active');
  }
  updateUI();
}

function updateTotalSummary() {
  const priceEls   = document.querySelectorAll('.js-total-price');
  const compareEls = document.querySelectorAll('.js-total-compare');

  let totalFinal   = Number(window.CF.CONSTANTS.CUBE_CUSTOM_BASE_CENTS) || 0;
  let totalCompare = totalFinal;

  const cover = getSelectedDisplayCover();
  const plaqueActive = !document.getElementById('addon-plaque-id')?.disabled;

  if (cover === 'acrylic') totalFinal += window.CF.PRODUCT_DATA.cover.acrylicPriceCents;
  if (cover === 'glass')   totalFinal += window.CF.PRODUCT_DATA.cover.glassPriceCents;
  if (plaqueActive) {
    /*
      The selected material's price: PLAQUE_UNIT_CENTS is variants[0], always steel, so a brass plaque showed at
      steel's price (2026-10-15; the cart line was right, the brass variant). As on the CUBE page (cc_configurator).
    */
    const mat = window.CF.CONSTANTS.PLAQUE_MATERIALS?.[window.CF.STATE?.plaqueMaterial];
    totalFinal += Number(mat?.priceCents) || Number(window.CF.CONSTANTS.PLAQUE_UNIT_CENTS) || 0;
  }

  priceEls.forEach(el => { el.innerText = formatPrice(totalFinal); });
  /*
    The amount is written into its own span and the <compare-at-price> around it is shown or hidden,
    which keeps the "Regular price" label for screen readers — see price-list.
  */
  compareEls.forEach(el => {
    const box = el.closest('compare-at-price') || el;
    if (totalCompare > totalFinal) {
      el.innerText = formatPrice(totalCompare);
      box.hidden = false;
    } else {
      box.hidden = true;
    }
  });
}

function updateUI() {
  updateDisplayCoverQuantities(1, getSelectedDisplayCover());
  updateDisplayCoverTotal();
  updatePlaqueTotal();
  updateTotalSummary();
  window.CF_CUBE_CUSTOM_updateAddonOverlays?.();
  clearError();
  /*  The buy box's rows for the cover and the plaque follow (assets/cf-cover-window.js, cf-plaque-designer.js). */
  document.dispatchEvent(new CustomEvent('cf:addon-change'));
}

function showError(message) {
  document.querySelectorAll('.error-note').forEach(el => {
    el.textContent = message;
    el.style.display = 'block';
  });
}

function clearError() {
  document.querySelectorAll('.error-note').forEach(el => {
    el.textContent = '';
    el.style.display = 'none';
  });
}

function validateSelections() {
  if (window.CF.STATE.choices.plaque === true) {
    const headline = document.getElementById('plaque-note-1');
    if (!headline || !headline.value.trim()) {
      return { valid: false, message: window.CF.T.validation.enter_plaque_text };
    }
  }
  return { valid: true, message: null };
}

function lockATCButtonsAddon(disabled, label) {
  allATC().forEach(btn => {
    btn.disabled = disabled;
    if (label) btn.innerText = label;
    else btn.innerText = window.CF.T.atc.add_to_cart;
    btn.classList.toggle('disabled', disabled);
    btn.classList.toggle('enabled', !disabled);
    btn.style.opacity = disabled ? '0.5' : '1';
    btn.style.cursor  = disabled ? 'not-allowed' : 'pointer';
  });
}
/*
  The design's own place, never the map's: a saved design opened later leaves the map wherever it was.
  The district is dropped when the geocoder returns it as the city too.
*/
function cfPlaceLabel(design) {
  const d = design || {};
  const city = (d.city || '').trim();
  const area = (d.area || '').trim();
  const country = (d.country || '').trim();
  const parts = [];
  if (area && area.toLowerCase() !== city.toLowerCase()) parts.push(area);
  if (city) parts.push(city);
  if (country) parts.push(country);
  return parts.join(', ')
    || (d.place_name || '').trim()
    || (document.getElementById('cube-custom-location-place')?.textContent || '').trim();
}

function buildCartItems() {
  const items = [];

  const mapState = window.CF_CUBE_CUSTOM_MAP?.getState?.() || {};
  const preview = window.CF_CUBE_CUSTOM_PREVIEW || {};

  const scale    = Number.isFinite(preview.scale) ? preview.scale : mapState.scale;
  const rotation = (preview.rotation !== undefined && preview.rotation !== null) ? preview.rotation : mapState.rotation;
  const lat = Number.isFinite(preview.lat) ? preview.lat : mapState.center?.lat;
  const lon = Number.isFinite(preview.lon) ? preview.lon : mapState.center?.lng;

  const mainProps = {};
  const place = cfPlaceLabel(preview);
  if (place) mainProps['Location'] = place;
  if (scale)    mainProps['Scale']    = `1:${scale}`;
  if (rotation !== undefined && rotation !== null) mainProps['Rotation'] = `${rotation}°`;
  if (Number.isFinite(lat) && Number.isFinite(lon)) mainProps['Coordinates'] = `${lat.toFixed(4)}, ${lon.toFixed(4)}`;

  if (preview.design_id)   mainProps['Design ID']   = preview.design_id;

  if (preview.trees)   mainProps['Trees']   = 'Yes';
  if (preview.streets) mainProps['Streets'] = 'Yes';
  /*
    The location marker (assets/cc-location-marker.js): which one and where, on the model's own line, as Trees and
    Streets are: the workshop's job card shows it there and the order records it with the design (save_api), and with
    two models in one order that line says which marker goes into which. The part itself is a line of its own below.
  */
  const marker = window.CF.MARKER?.current?.(preview.design_id);
  const markerVariant = marker && marker.on && (window.CF.MARKER_VARIANTS || {})[marker.shape];
  if (markerVariant) {
    mainProps['Location marker'] = marker.shape === 'heart' ? 'Heart' : 'Pin';
    mainProps['_Marker position'] = `${marker.x_mm}, ${marker.y_mm} mm`;
    mainProps['_Marker key'] = marker.key;
  }
  /*
    Trees and Streets are the model itself, so the line has to say which design they
    belong to. A cover and a plaque are add-ons packed beside it — their own lines say
    everything fulfilment needs, and nothing has to tie them back to a design.
  */

  const isDdpActive = document.querySelector('.ddp-tax-notice');
  if (isDdpActive) mainProps['Taxes & Duties'] = "Included. No extra fees on delivery.";
  /*
    The CUBE comes in two boxes and the printed height picks one; unknown height ships large: a tall model in the small
    box is the failure that matters. The FRAME has one variant, so its section gives the same id for both.
  */
  const C = window.CF.CONSTANTS;
  const h = preview.model_height_mm;
  const fitsSmall = typeof h === 'number' && h < C.LARGE_BOX_FROM_MM;
  items.push({
    id: parseInt(fitsSmall ? C.CUBE_CUSTOM_VARIANT_IDS.small : C.CUBE_CUSTOM_VARIANT_IDS.large, 10),
    quantity: 1,
    properties: Object.keys(mainProps).length ? mainProps : undefined
  });
  /* The marker's own line, as the cover's: no Design ID, which names the model's line. */
  if (markerVariant) items.push({ id: parseInt(markerVariant, 10), quantity: 1 });

  const cover = getSelectedDisplayCover();
  if (cover === 'acrylic') {
    items.push({ id: parseInt(window.CF.PRODUCT_DATA.cover.acrylicId, 10), quantity: 1 });
  } else if (cover === 'glass') {
    items.push({ id: parseInt(window.CF.PRODUCT_DATA.cover.glassId, 10), quantity: 1 });
  }

  const plaqueIdEl = document.getElementById('addon-plaque-id');
  if (plaqueIdEl && !plaqueIdEl.disabled) {
    const head = document.getElementById('plaque-note-1')?.value.trim() || '';
    const sub  = document.getElementById('plaque-subnote-1')?.value.trim() || '';
    if (head) {
      /*  No Sub-Headline line on the order when it is empty (Alex, 2026-10-16), as on the Set pages. */
      const props = { 'Headline': head };
      if (sub) props['Sub-Headline'] = sub;
      items.push({ id: parseInt(plaqueIdEl.value, 10), quantity: 1, properties: props });
    }
  }

  return items;
}
/*
  ── Persist the shopper's live configuration server-side (per design) ────────
  Reads the current selections and debounce-POSTs them to
  /design/{id}/config so reopening the design (here or on another device)
  restores exactly where they left off. Best-effort — never blocks the UI.
  Which option buttons the shopper has actually PRESSED, per design. Distinct
  from the trees/streets values below, which record the final choice: a design
  that ends with trees off looks identical to one where the control was never
  noticed, and those are different product questions. Sticky here and sticky
  server-side (the config POST ORs against the stored value), so a
  toggle-on-then-off still counts as engagement.
*/
window.CF.OPTION_TRIED = window.CF.OPTION_TRIED || {};
window.CF.markOptionTried = function (designId, which) {
  if (!designId || (which !== 'trees' && which !== 'streets')) return;
  const t = window.CF.OPTION_TRIED[designId] || (window.CF.OPTION_TRIED[designId] = {});
  if (t[which]) return; /* already recorded — no need to re-save */
  t[which] = true;
  window.CF.persistDesignConfig?.();
};

function cfReadLiveConfig() {
  const p  = window.CF_CUBE_CUSTOM_PREVIEW || {};
  const tried = (window.CF.OPTION_TRIED || {})[p.design_id] || {};
  const st = window.CF.STATE || {};
  const plaqueOn = !!(st.choices && st.choices.plaque);
  const cfg = {
    trees:   !!p.trees,
    streets: !!p.streets,
    cover:   (st.choices && st.choices.cover) || 'none',
    plaque:  plaqueOn ? (st.plaqueMaterial || 'steel') : 'none',
    plaque_headline:    (document.getElementById('plaque-note-1')?.value || '').trim(),
    plaque_subheadline: (document.getElementById('plaque-subnote-1')?.value || '').trim(),
    trees_tried:   !!tried.trees,
    streets_tried: !!tried.streets,
  };
  /* The location marker, on a page that has it (assets/cc-location-marker.js); without it the stored one stays. */
  if (window.CF.MARKER && window.CF.MARKER.current) cfg.marker = window.CF.MARKER.current(p.design_id);
  return cfg;
}
let cfConfigSaveTimer = null;
function cfPersistDesignConfig() {
  const id   = (window.CF_CUBE_CUSTOM_PREVIEW || {}).design_id;
  const base = (window.CF?.CONSTANTS?.PREVIEW_API_URL || '').replace(/\/$/, '');
  if (!id || !base) return;
  if (cfConfigSaveTimer) clearTimeout(cfConfigSaveTimer);
  cfConfigSaveTimer = setTimeout(() => {
    const body = cfReadLiveConfig();
    /*
      Keep the local draft in sync too, so reopening this design in the SAME
      browser restores the latest selections without waiting on the server.
    */
    window.CF.updateDesignBufferConfig?.(id, body);
    fetch(`${base}/design/${encodeURIComponent(id)}/config`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
    /*
      NOTE: we deliberately do NOT pre-render the combo's step-3 composite on an
      option switch — a combo's add-on is rendered only when the shopper actually
      proceeds to step 3 (see loadAddonBase). The gallery keeps the regular (model)
      product-shot until then, and upgrades to the combo shot once it exists.
    */
  }, 600);
}
window.CF = window.CF || {};
window.CF.persistDesignConfig = cfPersistDesignConfig;

async function postCartItems(items) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: items,
      attributes: { 'cube_custom_configurator': 'true' }
    })
  });
  if (!res.ok) {
    const errJson = await res.json().catch(() => ({}));
    throw new Error(errJson.description || res.statusText);
  }
  return res.json();
}

function openCartDrawerOrRedirect() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();
  else window.location.href = '/cart';
}
/*
  The height normally lands with the preview; this covers a design whose /preview answer never reached us. Only where
  the height picks the box (the CUBE): one variant for every height (the FRAME) needs no height.
*/
async function ensureModelHeight() {
  const p = window.CF_CUBE_CUSTOM_PREVIEW;
  const base = (window.CF?.CONSTANTS?.PREVIEW_API_URL || '').replace(/\/$/, '');
  const ids = window.CF?.CONSTANTS?.CUBE_CUSTOM_VARIANT_IDS || {};
  if (ids.small === ids.large) return;
  if (!p || !p.design_id || typeof p.model_height_mm === 'number' || !base) return;
  try {
    const res = await fetch(`${base}/preview/${encodeURIComponent(p.design_id)}`);
    const data = res.ok ? await res.json() : null;
    if (data && typeof data.model_height_mm === 'number') p.model_height_mm = data.model_height_mm;
  } catch (_) { }
}

async function handleAddToCart(e) {
  e.preventDefault();

  const mapState = window.CF_CUBE_CUSTOM_MAP?.getState?.() || {};

  const { valid, message } = validateSelections();
  if (!valid) { showError(message); return; }

  lockATCButtonsAddon(true, window.CF.T.atc.adding);
  try {
    await ensureModelHeight();
    const items = buildCartItems();
    if (!items || !items.length) { lockATCButtonsAddon(false); return; }
    await postCartItems(items);
    document.dispatchEvent(new Event('cart:refresh'));
    openCartDrawerOrRedirect();
  } catch (err) {
    console.error('Add to cart failed', err);
    /*  An add past a cover's or plaque's stock is refused with its own message (assets/cf-addon-stock.js). */
    alert((window.CFAddonStock && window.CFAddonStock.takeMessage()) || window.CF.T.atc.error_generic);
  } finally {
    lockATCButtonsAddon(false);
  }
}
/*
  A cover or plaque picked by click goes to our tracking as CustomizeProduct (snippets/cf-tracking.liquid).
  Here, not in setDisplayCover / setPlaque: those also run when a saved design is restored on load.
*/
function cfTrackCoverPick(cover) {
  const d = window.CF.PRODUCT_DATA.cover || {};
  const acrylic = cover === 'acrylic';
  if (window.cfCustomize) window.cfCustomize({
    id: acrylic ? d.acrylicId : d.glassId, cents: acrylic ? d.acrylicPriceCents : d.glassPriceCents,
    name: 'Display Cover', currency: window.CF.LOCALE && window.CF.LOCALE.currency
  });
}
function cfTrackPlaquePick(mat) {
  const def = window.CF.CONSTANTS.PLAQUE_MATERIALS && window.CF.CONSTANTS.PLAQUE_MATERIALS[mat];
  if (def && window.cfCustomize) window.cfCustomize({
    id: def.id, cents: def.priceCents, name: 'Engraved Plaque', currency: window.CF.LOCALE && window.CF.LOCALE.currency
  });
}

/*
  The cover's window and the plaque designer (assets/cf-cover-window.js, cf-plaque-designer.js; the CUBE page's since
  2026-10-30, here since 2026-10-31) reach this builder as they reach the CUBE page's script (assets/cf-pdp.js):
  window.CFCover and window.CFPlaque. A pick from a window goes to tracking and is saved with the design, as the option
  buttons' clicks did; model() is the picture of the visitor's own model for the cover window's preview, place() the
  place on the map in the shape of a variant record, for the plaque's choices (City name, Country, Coordinates...).
*/
window.CFCover = {
  get: () => getSelectedDisplayCover(),
  set(cover) {
    const was = getSelectedDisplayCover();
    setDisplayCover(cover);
    if (cover !== 'none' && cover !== was) cfTrackCoverPick(cover);
    cfPersistDesignConfig();
  },
  model: () => document.getElementById('cube-custom-addon-img')?.currentSrc || ''
};

window.CFPlaque = {
  material: () => (window.CF.STATE.choices.plaque ? window.CF.STATE.plaqueMaterial || 'steel' : 'none'),
  setMaterial(mat) {
    const was = window.CFPlaque.material();
    if (mat === 'steel' || mat === 'brass') {
      window.CF.STATE.plaqueMaterial = mat;
      setPlaque(mat);
      if (mat !== was) cfTrackPlaquePick(mat);
    } else {
      setPlaque('none');
    }
    window.CF_CUBE_CUSTOM_syncPlaqueText?.();
    cfPersistDesignConfig();
  },
  syncToGallery() {
    window.CF_CUBE_CUSTOM_syncPlaqueText?.();
    cfPersistDesignConfig();
  },
  place() {
    const st = window.CF_CUBE_CUSTOM_MAP?.getState?.() || {};
    const c = st.center || {};
    const lat = Number(c.lat), lon = Number(c.lng);
    const city = st.city || st.area || '';
    return {
      baseCity: city,
      variantCity: st.area && st.area !== city ? st.area : '',
      countryname: st.country || '',
      countrycode: st.countryCode || '',
      coordinates: Number.isFinite(lat) && Number.isFinite(lon) ? `${_plaqueToDMS(lat, 'N', 'S')}, ${_plaqueToDMS(lon, 'E', 'W')}` : '',
      scale: st.scale ? `1:${st.scale}` : ''
    };
  }
};

function initAddonBindings() {
  allATC().forEach(btn => btn.addEventListener('click', handleAddToCart));

  /*  Typing in the designer: the gallery's plaque follows, and the words are saved with the design. */
  ['plaque-note-1', 'plaque-subnote-1'].forEach((id) => {
    document.getElementById(id)?.addEventListener('input', () => {
      window.CF_CUBE_CUSTOM_syncPlaqueText?.();
      cfPersistDesignConfig();
    });
  });
}

function _plaqueToDMS(value, pos, neg) {
  const dir = value >= 0 ? pos : neg;
  const abs = Math.abs(value);
  const deg = Math.floor(abs);
  const mF  = (abs - deg) * 60;
  const min = Math.floor(mF);
  const sec = ((mF - min) * 60).toFixed(2); /* 2 decimals, e.g. 49.55 */
  return `${deg}°${String(min).padStart(2, '0')}′${sec.padStart(5, '0')}″${dir}`;
}

/*
  The plaque's words set from outside the designer - a saved design restored (assets/cf-custom-preview.js): the
  gallery's plaque and the buy box's row follow. The old window's own preview went with it (2026-10-31).
*/
function updatePlaqueModalPreview() {
  window.CF_CUBE_CUSTOM_syncPlaqueText?.();
  document.dispatchEvent(new CustomEvent('cf:addon-change'));
}

function init() {
  cfInitAddonVariants();
  initAddonBindings();
  updateUI();
}

(() => { document.addEventListener('DOMContentLoaded', init); })();
